exports.IonRangeSliderModule = require('./lib/ion-range-slider.module').IonRangeSliderModule;
exports.IonRangeSliderComponent = require('./lib/ion-range-slider.component').IonRangeSliderComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-ion-range-slider/index.js
// module id = 608
// module chunks = 21